import * as React from "react";
import LabelWrapper, { ILabelWrapperProps } from "./Wrapper";
import TextBoxWithKeyboard, { ITextBoxWithKeyboardProps } from "../TextBoxWithKeyboard";

interface ITextBoxWithKeyboardLabeled extends ILabelWrapperProps, ITextBoxWithKeyboardProps {}

export default function TextBoxWithKeyboardLabeled(props: ITextBoxWithKeyboardLabeled) {
    const { label, children, labelMarginTop, testId, ...rest } = props as any;
    return (
        <LabelWrapper label={label} labelMarginTop={labelMarginTop} >
            <TextBoxWithKeyboard label={""} {...rest}  testId={testId}>
                    {children}
            </TextBoxWithKeyboard>
        </LabelWrapper>
    );
}
